const Loader = ({ size = "w-10 h-10" }) => {
  return (
    <div className="flex items-center justify-center">
      <div
        className={`
          ${size}
          border-4
          border-gray-300
          border-t-blue-600
          rounded-full
          animate-spin
        `}
      ></div>
    </div>
  );
};

export default Loader;
